<template>
  <div>
    <ButtonBack class="mb_m"/>
    <div class="input">
      <div class="input-label">お知らせ</div>
      <div class="input-group">
        <textarea
          rows="3"
          class="input-textarea"
          v-model="content"
          :placeholder="placeholderContent">
        </textarea>
      </div>
    </div>

    <slot></slot>
  </div>
</template>

<script>
import ButtonBack from '@/components/ButtonBack'

export default {
  components: {
    ButtonBack
  },

  computed: {
    placeholderContent: function () {
      if (this.$route.name == 'info-new') {
        return '内容は必須です。'
      }
      return ''
    },

    content: {
      get: function () {
        return this.$store.state.info.content
      },

      set: function (value) {
        this.$store.commit(
          'info/setContent',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss'
</style>
